import { Guid } from '@web/utils';
import { ShippingMethodCode } from '../../enums';
import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class ShippingMethodDictionaryResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly code!: ShippingMethodCode;

  @jsonMember(String)
  public readonly name!: string;
}
